<script lang="ts" setup>
import Table from '@/domains/investor/components/Table/Table.vue'
import type { IProps } from './AnalyticsTable.types'

defineProps<IProps>()
</script>

<template>
  <div class="analytics-table">
    <div class="analytics-table__container">

      <UiHeader
        :header="$t('investor.stock.recommendation.analyticsHeading')"
        position="center"
        header-size="h5"
        header-size-tablet="h5"
        header-size-mobile="h5"
      />

      <Table
        class="analytics-table__table"
        :table="table"
      />
    </div>
  </div>
</template>

<style scoped lang="scss">
.analytics-table {
  @include section-investor();

  &__container {
    @include section-investor__container();
  }

  :deep(p) {
    text-align: left;
  }

  :deep(a) {
    color: #2C5EC5;
    text-decoration: underline;

    &:hover {
      text-decoration: none;
    }
  }
}
</style>
